/**
 * Werte aus dem Schritttext lesen: Minuten, Gramm, Milliliter. Die Vorlagen
 * nutzen diese Hilfen in inferValues, damit „20 Minuten köcheln“ gleich mit
 * der richtigen Zeit vorgeschlagen wird.
 */

/** Zahl mit Komma oder Punkt. */
function parseNumber(text: string): number {
  return Number(text.replace(',', '.'));
}

/** Minuten aus „20 Min.“, „20 Minuten“, „1 Stunde“, „1,5 Std.“. Bei Spannen gilt der größere Wert. */
export function minutesFromText(text: string): number | undefined {
  const lower = text.toLowerCase();
  const hours = /(\d+(?:[.,]\d+)?)\s*(?:-|–|bis)?\s*(\d+(?:[.,]\d+)?)?\s*(?:std|stunde)/.exec(lower);
  if (hours?.[1] !== undefined) {
    return Math.round(parseNumber(hours[2] ?? hours[1]) * 60);
  }
  const minutes = /(\d+)\s*(?:-|–|bis)?\s*(\d+)?\s*(?:min)/.exec(lower);
  if (minutes?.[1] !== undefined) {
    return Number(minutes[2] ?? minutes[1]);
  }
  return undefined;
}

/** Gramm aus „250 g“, „1,5 kg“. */
export function gramsFromText(text: string): number | undefined {
  const lower = text.toLowerCase();
  const kilo = /(\d+(?:[.,]\d+)?)\s*kg\b/.exec(lower);
  if (kilo?.[1] !== undefined) {
    return Math.round(parseNumber(kilo[1]) * 1000);
  }
  const gram = /(\d+(?:[.,]\d+)?)\s*(?:g|gramm)\b/.exec(lower);
  return gram?.[1] === undefined ? undefined : Math.round(parseNumber(gram[1]));
}

/** Milliliter aus „200 ml“, „0,5 l“, „1/2 Liter“. */
export function millilitresFromText(text: string): number | undefined {
  const lower = text.toLowerCase();
  const ml = /(\d+(?:[.,]\d+)?)\s*ml\b/.exec(lower);
  if (ml?.[1] !== undefined) {
    return Math.round(parseNumber(ml[1]));
  }
  const half = /1\/2\s*(?:l|liter)\b/.exec(lower);
  if (half !== null) {
    return 500;
  }
  const litre = /(\d+(?:[.,]\d+)?)\s*(?:l|liter)\b/.exec(lower);
  return litre?.[1] === undefined ? undefined : Math.round(parseNumber(litre[1]) * 1000);
}
